import camelCase from "lodash/camelCase";
import merge from "lodash/merge";
import normalize from "json-api-normalizer";
import omit from "lodash/omit";
import get from "lodash/get";
import map from "lodash/map";
import mapValues from "lodash/mapValues";
import mapKeys from "lodash/mapKeys";

const generateField = (arr, ci) => {
  if (ci + 1 < arr.length) {
    return `${arr[ci]}[${generateField(arr, ci + 1)}]`;
  }
  return camelCase(`${arr[ci]}`);
};

const jsonFormatter = (data) => {
  Object.keys(data).map((menuKey) => {
    const menuObj = data[menuKey];
    Object.keys(menuObj).map((itemKey) => {
      const itemObj = menuObj[itemKey];
      if (itemObj.relationships) {
        Object.keys(itemObj.relationships).map((relKey) => {
          const relObj = itemObj.relationships[relKey];
          itemObj.relationships[relKey] = relObj.data;
        });
      }
      data[menuKey][itemKey] = {
        ...omit(itemObj, ["relationships", "attributes"]),
        ...itemObj.relationships,
        ...itemObj.attributes,
      };
    });
  });

  return data;
};

export const jsonDataFormatter = (data) => jsonFormatter(normalize(data));

export const jsonErrorFormatter = (errorResponse, parentKey) => {
  const errorArr =
    errorResponse && errorResponse.data && Array.isArray(errorResponse.data.errors)
      ? errorResponse.data.errors
      : [];
  let errors = {};
  (errorArr || []).map((errorObj) => {
    const src = errorObj?.source?.pointer?.split("/") || [];
    const field = generateField(src.slice(3), 0);
    errors = merge({}, errors, { [parentKey]: { [field]: errorObj.detail } });
  });
  return errors;
};

const objectParser = (data, nData) => {
  Object.keys(data).forEach((key) => {
    nData[camelCase(key)] = camelizer(data[key]);
  });
  return nData;
};

const arrayParser = (data, nData) => {
  data.forEach((el, idx) => {
    nData[camelCase(idx)] = camelizer(el);
  });
  return nData;
};

export const camelizer = (data) => {
  if (Array.isArray(data)) {
    return arrayParser(data, []);
  } else if (data && typeof data == "object") {
    return objectParser(data, {});
  }
  return data;
};

// This method fills corresponding values in the serialized data.
// For Eg - product : { id: 123, type: "spreeProducts" } becomes product: { id: 123, name: "abc", price : 23, ...rest }
// This accepts an array or an object as 'serializedObject' and returns the same if value not found.
export const getPopulatedSerializedData = (serialiazedObject, responseData = {}) => {
  const getData = (obj) => {
    const id = obj?.id;
    const type = obj?.type;
    return get(responseData, `${type}.${id}`, obj);
  };

  const dataMappingIterator = (value) => {
    if (Array.isArray(value)) {
      return value.map((obj) => getPopulatedSerializedData(getData(obj), responseData));
    }
    if (value?.id && value?.type) {
      return getPopulatedSerializedData({ ...value, ...getData(value) }, responseData);
    }
    return value;
  };

  const mappingMethod = Array.isArray(serialiazedObject)
    ? map
    : serialiazedObject instanceof Object
    ? mapValues
    : null;
  return mappingMethod?.(serialiazedObject, dataMappingIterator) || serialiazedObject;
};

export const camelizeKeys = (obj = {}) => mapKeys(obj, (v, k) => camelCase(k));

export const transformObject = (object, mapKeyFunc, mapValueFunc) =>
  Object.entries(object).reduce((parsedValue, [key, value]) => {
    parsedValue[mapKeyFunc(key, value)] = mapValueFunc(value);
    return parsedValue;
  }, {});
